<template>
  <modal>
    <template v-slot:full>
      <div class="bg-white p-3 m-3 rounded-md">
        <p>
          {{ $t("views.update.internet_connection") }}
        </p>
        <button
          v-if="showButton"
          class="p-3 my-4 rounded-lg text-white bg-gradient-blue font-bold"
          @click="closeApp"
        >
          {{ $t("views.update.close_app") }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/layouts/Modal";

export default {
  name: "ImportFailedModal",
  components: { Modal },
  methods: {
    closeApp() {
      navigator.app.exitApp();
    }
  },
  computed: {
    showButton: () => {
      return process.env.VUE_APP_PLATFORM === "android";
    }
  }
};
</script>
